import { breakpoints, Image } from '@gassan-ui'
import React, { FC, ImgHTMLAttributes } from 'react'
import styled from 'styled-components'

const sizesMobile = {
  regular: '32%',
  large: '37.5%',
  xlarge: '64%'
}
const sizesDesktop = {
  regular: '15%',
  large: '29%',
  xlarge: '64%'
}

const Container = styled.section<{ size: string }>`
  position: relative;
  margin: 0 auto;
  background: ${p => p.theme.rolex.colors.shades[200]};

  &::before {
    padding-top: ${p => sizesMobile[p.size]};
    content: '';
    display: block;
    @media screen and (min-width: ${breakpoints.large}) {
      padding-top: ${p => sizesDesktop[p.size]};
    }
  }
  div {
    position: absolute;
    top: 0;
    left: 0;
  }
`

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  size?: 'regular' | 'large' | 'xlarge'
  sources: string[]
}

const Hero: FC<Props> = ({ size = 'regular', sources }) => {
  return (
    <Container size={size}>
      <Image width="100%" height="100%" sources={sources} loading="eager" />
    </Container>
  )
}

export default Hero
